export default "__VITE_ASSET__oxaWQHy5__"